import api from "../api";

export const state = {
  discount: null,
  voucherError: false,

  error: null,
  hasError: false,
  countries: [],
  countryListLoading: false,

  buttonLoading: false,
  loading: false
};

export const mutations = {
  SET_LOADING(state, payload) {
    state.loading = payload;
  },

  SET_BUTTON_LOADING(state, payload) {
    state.buttonLoading = payload;
  },

  SET_DISCOUNT(state, payload) {
    state.discount = payload;
  }
};

export const actions = {
  async getCountryList({ state }) {
    state.countryListLoading = true;
    const { data, status } = await api("get", "/universal/country", "");

    if (!status) {
      state.countryListLoading = false;
      return;
    }

    state.countries = data.data;
    state.countryListLoading = false;
  },

  async submit({ dispatch, state }, payload) {
    state.buttonLoading = true;
    state.loading = true;
    const { data, status } = await api(
      "post",
      "/web/store/orders",
      payload.form
    );

    if (!(status && data.status === 200)) {
      dispatch(
        "alert/setContent",
        {
          title: "Sorry",
          message:
            "We weren’t able to complete your purchase at this time due to congestion. In case of any difficulties  contact us at support@upmood.com",
          button: "Close",
          hasError: true
        },
        { root: true }
      );
      dispatch("alert/toggleAlert", true, { root: true });
      state.buttonLoading = false;
      state.loading = false;
      return;
    }

    let newWin = null;
    newWin = window.open(
      "https://www.sandbox.paypal.com/us/cgi-bin/webscr?cmd=_logout",
      "_blank"
    );

    if (newWin) newWin.close();

    payload.vue.clearData();
    dispatch(
      "alert/setContent",
      {
        title: "Thank you for ordering!",
        message: "Please check your email for your order status.",
        button: "Ok",
        hasError: false,
        onClose: () => {
          location.reload();
        }
      },
      { root: true }
    );
    dispatch("alert/toggleAlert", true, { root: true });
    state.buttonLoading = false;
    state.loading = false;
  },

  async validateInfo({ state }, payload) {
    state.buttonLoading = true;
    const { data, status } = await api("post", "/web/store/validate", payload);

    if (!(status && data.status === 200)) {
      state.error = data.errors;
      state.hasError = true;
      state.buttonLoading = false;
      return;
    }

    state.error = null;
    state.hasError = false;
    state.buttonLoading = false;
  },

  async enterVoucher({ state }, payload) {
    state.buttonLoading = true;
    const { data, status } = await api("post", "/web/store/vouchers", payload);

    if (!(status && data.status === 200)) {
      state.voucherError = true;
      state.discount = null;
      state.buttonLoading = false;
      return;
    }

    state.voucherError = false;
    state.discount = data.data;
    state.buttonLoading = false;
  }
};

export const getters = {
  getDiscount: state => state.discount,
  getVoucherError: state => state.voucherError,

  getError: state => state.error,
  getHasError: state => state.hasError,
  getCountries: state => state.countries,
  getCountryListLoading: state => state.countryListLoading,

  getButtonLoading: state => state.buttonLoading,
  getLoading: state => state.loading
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};
